export var isEqualPreset = function (value, theme) {
    var suitsValue = value.cards.suits;
    var suitsTheme = theme.cards.suits;
    return (JSON.stringify({
        actions: value.actions,
        hotkeys: value.hotkeys,
        matrix: value.matrix,
        positions: value.positions,
        trainer: value.trainer,
        cards: { suits: suitsValue },
    }) ===
        JSON.stringify({
            actions: theme.actions,
            hotkeys: theme.hotkeys,
            matrix: theme.matrix,
            positions: theme.positions,
            trainer: theme.trainer,
            cards: { suits: suitsTheme },
        }));
};
export var isEqualPresetProperty = function (presetProp, themeProp) {
    return JSON.stringify(presetProp) === JSON.stringify(themeProp);
};
